export default __webpack_public_path__ + "static/media/close.4bcb9a0b.svg";